(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('ReserveLimitController', ReserveLimitController);

    ReserveLimitController.$inject = ['$scope', '$state', 'ReserveLimit', 'PersonInfo', 'Customer', 'ParseLinks', 'AlertService', 'entity', 'CustomerCustom', 'ReserveLimitCustom', '$mdDialog', '$translatePartialLoader', 'ServiceItemCustom', 'CustomerGroupCustom'];

    function ReserveLimitController($scope, $state, ReserveLimit, PersonInfo, Customer, ParseLinks, AlertService, entity, CustomerCustom, ReserveLimitCustom, $mdDialog, $translatePartialLoader, ServiceItemCustom, CustomerGroupCustom) {

        var vm = this;
        vm.reserveLimit = entity;
        vm.loadAll = loadAll;
        loadAll();
        vm.save = save;
        vm.hasAllNecessaryFields = true;
        vm.columnCount = null;
        vm.allServiceItems = [];
        vm.switch_changed = switch_changed;
        vm.forAllServices = true;
        vm.forAllCustomerGroups = true;
        vm.switch_customerGroup_changed = switch_customerGroup_changed;
        vm.allCustomerGroups = [];
        vm.hasDayCount = false;
        vm.dayCount_switch_changed = dayCount_switch_changed;
        vm.basedOnNationalCodeSwitch = false;
        vm.basedOnNationalCode_changed = basedOnNationalCode_changed;
        initDefault();
        loadAll();

        function initDefault() {
            if (!vm.reserveLimit.limitType)
                vm.reserveLimit.limitType = "RESERVE";

            if (!vm.reserveLimit.status)
                vm.reserveLimit.status = "ACTIVE";

            if (vm.reserveLimit.dayCount != null && vm.reserveLimit.dayCount > 0) {
                vm.hasDayCount = true;
            }

        }

        function loadAll() {
            $translatePartialLoader.addPart('companyCustomer');
            $translatePartialLoader.addPart('reserveLimitTypes');
            getAllServices();
            getAllCustomerGroups();
            setBasedOnTypeSwitch();
        }

        function getAllServices() {

            ServiceItemCustom.getServiceItemsByCurrentCompany().query().$promise.then(function (result) {
                    vm.allServiceItems = result;
                    makeServicesSelectedOnLoad();
                }
            );
        }

        function getAllCustomerGroups() {

            CustomerGroupCustom.getCustomerGroupsByCurrentCompany().query().$promise.then(function (result) {
                    vm.allCustomerGroups = result;
                    makeCustomerGroupsSelectedOnLoad();
                }
            );
        }

        function save() {
            vm.isSaving = true;
            addServiceItems();
            addCustomerGroups();

            if (vm.reserveLimit.id !== null) {
                ReserveLimit.update(vm.reserveLimit, onSaveSuccess, onSaveError);
            } else {

                ReserveLimit.save(vm.reserveLimit, onSaveSuccess, onSaveError);

            }

            function onSaveError() {
                vm.isSaving = false;
            }

            function onSaveSuccess(result) {
                $scope.$emit('tikonApp:reserveLimitUpdate', result);
                $state.go('supplierPanel.editReserveLimit', {id: result.id});

                loadAll();

            }

        }

        function switch_changed() {
            if (vm.forAllServices) {
                angular.forEach(vm.allServiceItems, function (item) {
                    item.selected = false;
                })

            } else {

            }
        }

        function switch_customerGroup_changed() {
            if (vm.forAllCustomerGroups) {
                angular.forEach(vm.allCustomerGroups, function (item) {
                    item.selected = false;
                })

            } else {

            }
        }


        function addServiceItems() {

            vm.reserveLimit.serviceItems = [];
            angular.forEach(vm.allServiceItems, function (item) {

                if (item.selected) {
                    vm.reserveLimit.serviceItems.push(item);
                }

            })
        }

        function addCustomerGroups() {

            vm.reserveLimit.customerGroups = [];
            angular.forEach(vm.allCustomerGroups, function (item) {

                if (item.selected) {
                    vm.reserveLimit.customerGroups.push(item);
                }

            })
        }

        function makeServicesSelectedOnLoad() {


            if (vm.reserveLimit.serviceItems && vm.reserveLimit.serviceItems.length > 0) {
                vm.forAllServices = false;


                angular.forEach(vm.reserveLimit.serviceItems, function (item) {
                    angular.forEach(vm.allServiceItems, function (allItem) {
                        if (allItem.id == item.id)
                            allItem.selected = true;
                    })

                })

            }
        }


        function makeCustomerGroupsSelectedOnLoad() {


            if (vm.reserveLimit.customerGroups && vm.reserveLimit.customerGroups.length > 0) {
                vm.forAllCustomerGroups = false;


                angular.forEach(vm.reserveLimit.customerGroups, function (item) {
                    angular.forEach(vm.allCustomerGroups, function (allItem) {
                        if (allItem.id == item.id)
                            allItem.selected = true;
                    })

                })

            }
        }

        function dayCount_switch_changed() {
            if (!vm.hasDayCount) {
                vm.reserveLimit.dayCount = 0;
            } else {
                vm.reserveLimit.dayCount = 15;
            }
        }

        function basedOnNationalCode_changed() {
            if (vm.basedOnNationalCodeSwitch) {
                vm.reserveLimit.basedOnType = 'NATIONAL_CODE';
            } else {
                vm.reserveLimit.basedOnType = 'PHONE_NUMBER';
            }
        }

        function setBasedOnTypeSwitch() {
            if (vm.reserveLimit.basedOnType && vm.reserveLimit.basedOnType == 'NATIONAL_CODE')
                vm.basedOnNationalCodeSwitch = true;
            else
                vm.basedOnNationalCodeSwitch = false;
        }
    }
})();
